import React from 'react';
import { Bell } from 'lucide-react';
import { translate } from '@utils/i18n';
import { cn } from '@utils/tailwind-class.merge';
import { useAlertsDrawer } from '_clean-code/contexts/AlertsDrawerContext';

export function AlertsBellButton() {
  const { toggle, isOpen, unreadCount } = useAlertsDrawer();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={translate('toggle_alerts_panel')}
      aria-expanded={isOpen}
      className={cn(
        'tw-flex tw-items-center tw-justify-center',
        'tw-h-9 tw-w-9 tw-rounded-md tw-border tw-border-[#e5e7eb]',
        'tw-bg-white tw-cursor-pointer tw-transition-colors',
        'hover:tw-bg-gray-50',
        isOpen && 'tw-bg-gray-100'
      )}
    >
      <span className="tw-relative tw-shrink-0">
        <Bell size={20} strokeWidth={1.5} color="#374151" />
        {unreadCount > 0 && (
          <span className="tw-absolute -tw-top-0.5 -tw-right-0.5 tw-h-2 tw-w-2 tw-rounded-full tw-bg-red-500 tw-pointer-events-none" />
        )}
      </span>
    </button>
  );
}

export default AlertsBellButton;
